











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopBarAvatar_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "picture",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StandardHubUserMenu_viewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node ).hash = "cf31f0029a96a58fa21c27f140120320";

export default node;
